import React from 'react';
import { Button } from '@heroui/react';
import appConfig from '@/utils/appConfig';
import clsx from 'clsx';

interface ButtonProps {
    label: string;
    onPress?: () => void;
    primary?: boolean;
    small?: boolean;
    className?: string;
    disabled?: boolean;
}
export default function App({
    label,
    onPress,
    primary = true,
    small = false,
    className,
    disabled = false,
}: ButtonProps) {
    const buttonClass = primary
        ? appConfig.colors.buttonPrimary
        : appConfig.colors.buttonSecondary;

    const buttonClasses = clsx(
        buttonClass,
        small ? 'px-2 py-1' : 'p-2',
        small ? 'text-sm md:text-md' : 'text-md md:text-xl',
        'font-extrabold',
        'text-white',
        'drop-shadow-[6px_6px_0_#efe9e9]',
        primary ? 'hover:bg-[#8ca147]' : 'hover:bg-[#A3C159]',
        // Disable hover effects when disabled
        disabled && 'opacity-50 cursor-not-allowed hover:opacity-50',
        className && className
    );

    return (
        <Button
            type="submit"
            className={buttonClasses}
            onPress={() => {
                if (!disabled && onPress) {
                    // Prevent onPress when disabled
                    onPress();
                }
            }}
            disabled={disabled} // Pass disabled to NextUI Button
            variant="bordered"
        >
            {label}
        </Button>
    );
}
